//============================
//# immetreport
//============================

export default interface MetRiportItem {
    id: number;
    name: string;
    accCode: string | null;
    metisHead: number;
    metisCode: string | null;
    notPcCode: boolean;
    dmsCode: string | null;
    metType: number; //csmetrepitemtype
    pcCode1: string | null;
    pcCode2: string | null;
    pcCode3: string | null;
    pcCode4: string | null;
    pcCode5: string | null;
    pcCode6: string | null;
    calcWithDefault: boolean;
    defaultValue: number;

    inEdit: boolean;
    showDetails: boolean;
    selectToRemove: boolean;
    selected: boolean;
    mapped: boolean;
}

export const MetRiportItemDefaultProps: MetRiportItem = {
    id: 0,
    name: "",
    accCode: null,
    metisHead: 0,
    metisCode: null,
    notPcCode: false,
    dmsCode: null,
    metType: 1, //csmetrepitemtype
    pcCode1: "0",
    pcCode2: "0",
    pcCode3: "00",
    pcCode4: "00",
    pcCode5: "0",
    pcCode6: "0",
    calcWithDefault: false,
    defaultValue: 0,

    inEdit: false,
    showDetails: false,
    selectToRemove: false,
    selected: false,
    mapped: true,
}